import styled from 'styled-components';

import { FooterRow } from '@sharedComponents/FooterRow';
import { StyledCenteredDiv } from '@styles/generalStyles';

export const ErrorWrapper = styled(StyledCenteredDiv)`
  flex-direction: column;
  width: 100%;
`;

export const StyledButtons = styled(FooterRow)`
  margin-top: 3rem;
  width: 100%;
`;

export const StyledErrorMessage = styled.p`
  text-align: center;
  font-weight: bold;
  margin-top: 3rem;
`;
